<app-loader></app-loader>
<main class="iguau-profile-settings">
  <header class="settings-heading">
    <div class="settings-heading-icon"><i class="fa-solid fa-sliders" aria-hidden="true"></i></div>
    <div class="settings-heading-copy">
      <span class="settings-eyebrow">MI CUENTA</span>
      <h1>Configuración de la cuenta</h1>
      <p>Gestiona tu privacidad, el acceso y tus preferencias en iGuau<span *ngIf="misdatos?.first_name">, {{misdatos.first_name}}</span>.</p>
    </div>
    <button type="button" class="btn settings-back" (click)="volverPerfil()"><i class="fa-solid fa-arrow-left" aria-hidden="true"></i> Mi perfil</button>
  </header>

  <div class="settings-layout" *ngIf="!modificar && !busy">
    <div class="settings-primary">
      <section class="settings-panel" aria-labelledby="ig-privacidad">
        <div class="settings-panel-heading">
          <div class="settings-panel-icon"><i class="fa-solid fa-shield-halved" aria-hidden="true"></i></div>
          <div><h2 id="ig-privacidad">Privacidad del perfil</h2><p>Controla quién puede encontrarte y ver tus mascotas.</p></div>
        </div>
        <div class="settings-choice-list" role="radiogroup" aria-label="Visibilidad del perfil">
          <label class="settings-choice" [class.is-selected]="opciones.privacidad.perfilPublico === true">
            <input type="radio" name="privacidad" [(ngModel)]="opciones.privacidad.perfilPublico" [value]="true">
            <span class="settings-choice-icon"><i class="fa-solid fa-earth-europe" aria-hidden="true"></i></span>
            <span class="settings-choice-text"><strong>Perfil público</strong><small>Otros usuarios pueden ver tu perfil, fotos y mascotas.</small></span>
          </label>
          <label class="settings-choice" [class.is-selected]="opciones.privacidad.perfilPublico === false">
            <input type="radio" name="privacidad" [(ngModel)]="opciones.privacidad.perfilPublico" [value]="false">
            <span class="settings-choice-icon"><i class="fa-solid fa-lock" aria-hidden="true"></i></span>
            <span class="settings-choice-text"><strong>Perfil privado</strong><small>Tu perfil y tus mascotas no estarán visibles para otros usuarios.</small></span>
          </label>
        </div>
      </section>

      <section class="settings-panel" aria-labelledby="ig-security">
        <div class="settings-panel-heading">
          <div class="settings-panel-icon"><i class="fa-solid fa-key" aria-hidden="true"></i></div>
          <div><h2 id="ig-security">Acceso y seguridad</h2><p>Protege tu cuenta y gestiona cómo inicias sesión.</p></div>
        </div>
        <div class="settings-subsection" *ngIf="misdatos?.login_provider && misdatos.login_provider != 'email'">
          <strong>Acceso con {{misdatos.login_provider}}</strong>
          <div class="settings-note"><i class="fa-solid fa-circle-info" aria-hidden="true"></i><span>Tu cuenta utiliza {{misdatos.login_provider}}. Para cambiar la contraseña, hazlo desde esa plataforma.</span></div>
        </div>
        <div class="settings-subsection" *ngIf="misdatos?.login_provider == 'email'">
          <strong>Contraseña</strong>
          <p>Actualiza tu contraseña periódicamente para mantener tu cuenta segura.</p>
          <div *ngIf="opciones.seguridad.cambiarContrasena" class="settings-password-fields">
            <label>Contraseña actual <input type="password" class="form-control" autocomplete="current-password" [(ngModel)]="opciones.seguridad.password_actual"></label>
            <label>Nueva contraseña <input type="password" class="form-control" autocomplete="new-password" [(ngModel)]="opciones.seguridad.password_nueva"></label>
            <label>Confirmar nueva contraseña <input type="password" class="form-control" autocomplete="new-password" [(ngModel)]="opciones.seguridad.password_confirmacion"></label>
          </div>
          <div class="settings-actions-inline">
            <button class="btn btn-primary" type="button" (click)="cambiarContrasena()" [disabled]="opciones.seguridad.cambiarContrasena && (!opciones.seguridad.password_actual || !opciones.seguridad.password_nueva || !opciones.seguridad.password_confirmacion)"><i class="fa-solid fa-key" aria-hidden="true"></i> {{opciones.seguridad.cambiarContrasena ? 'Actualizar contraseña' : 'Cambiar contraseña'}}</button>
            <button *ngIf="opciones.seguridad.cambiarContrasena" class="btn btn-outline-secondary" type="button" (click)="cancelarContrasena()">Cancelar</button>
          </div>
        </div>
        <div class="settings-subsection">
          <strong>Cuenta vinculada</strong>
          <p>Vincula Google para acceder más fácilmente a tu cuenta.</p>
          <div id="google-btn" *ngIf="misdatos?.login_provider != 'google'"></div>
          <div *ngIf="misdatos?.login_provider == 'google'" class="settings-connected"><i class="fa-brands fa-google" aria-hidden="true"></i> Google conectado</div>
        </div>
      </section>

      <section class="settings-panel settings-notifications" aria-labelledby="ig-notificaciones">
        <div class="settings-panel-heading">
          <div class="settings-panel-icon"><i class="fa-regular fa-bell" aria-hidden="true"></i></div>
          <div><h2 id="ig-notificaciones">Notificaciones</h2><p>Elige los avisos que quieres recibir.</p></div>
        </div>
        <div class="settings-note"><i class="fa-solid fa-clock" aria-hidden="true"></i><span>Las preferencias de notificaciones por correo estarán disponibles próximamente.</span></div>
      </section>
    </div>

    <aside class="settings-secondary">
      <section class="settings-panel settings-danger" aria-labelledby="ig-cuenta">
        <div class="settings-panel-heading">
          <div class="settings-panel-icon"><i class="fa-solid fa-user-gear" aria-hidden="true"></i></div>
          <div><h2 id="ig-cuenta">Gestionar cuenta</h2><p>Opciones sobre la disponibilidad de tu perfil.</p></div>
        </div>
        <div class="settings-subsection">
          <strong>Desactivar temporalmente</strong>
          <p>Tu perfil dejará de mostrarse, pero conservarás tus datos para volver más adelante.</p>
          <button class="btn settings-neutral-button" type="button" (click)="desactivarCuenta()"><i class="fa-solid fa-user-slash" aria-hidden="true"></i> Desactivar cuenta</button>
        </div>
        <div class="settings-subsection settings-delete">
          <strong>Eliminar mi cuenta</strong>
          <p>Esta acción es permanente y no se puede deshacer.</p>
          <button class="btn settings-delete-button" type="button" (click)="eliminarCuenta()"><i class="fa-solid fa-trash-can" aria-hidden="true"></i> Eliminar cuenta</button>
        </div>
      </section>
      <section class="settings-panel settings-help" aria-labelledby="ig-ayuda">
        <div class="settings-panel-heading">
          <div class="settings-panel-icon"><i class="fa-regular fa-circle-question" aria-hidden="true"></i></div>
          <div><h2 id="ig-ayuda">Ayuda e información</h2><p>Estamos aquí para ayudarte.</p></div>
        </div>
        <p>iGuau es una comunidad para compartir momentos, conocer personas y disfrutar con tus mascotas.</p>
        <p>Si necesitas asistencia, utiliza los canales de contacto de iGuau.</p>
      </section>
    </aside>
  </div>

  <div *ngIf="modificar || busy" class="settings-panel settings-role-state" aria-live="polite">
    <div *ngIf="busy"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Actualizando preferencias…</div>
    <div *ngIf="modificar && !busy">
      <h2>Tipo de perfil</h2>
      <p>Elige el perfil que mejor se adapte a ti.</p>
      <div class="settings-role-list">
        <button type="button" class="settings-role" *ngFor="let rolp of roles" [class.is-selected]="rolp.va_id == misdatos.rol_perfil" (click)="modificarPerfil(rolp.va_id)"><span [innerHTML]="rolp.va_extra"></span><span><strong>{{rolp.va_nombre}}</strong><small>{{rolp.va_descripcion}}</small></span></button>
      </div>
      <button type="button" class="btn btn-outline-secondary mt-3" (click)="cambioPerfil()">Cancelar</button>
    </div>
  </div>

  <footer class="settings-footer" *ngIf="!modificar && !busy">
    <span>Los cambios de privacidad se aplicarán al guardar.</span>
    <div class="settings-actions-inline">
      <button class="btn btn-outline-secondary" type="button" (click)="volverPerfil()">Volver al perfil</button>
      <button class="btn btn-primary" type="button" (click)="guardarCambios()"><i class="fa-solid fa-check" aria-hidden="true"></i> Guardar cambios</button>
    </div>
  </footer>
</main>
